export default __webpack_public_path__ + "static/media/logo.1aab66a9.png";